import image1 from "../Images/Flowers/charming-fantasy.jpg";
import image2 from "../Images/Flowers/Gorgeous Purple Orchids.jpg";
import image3 from "../Images/Flowers/red-carnival-by-blooms-villa.jpg";
import image4 from "../Images/Flowers/pink-serenity.webp";
import image5 from "../Images/Flowers/gorgeous-beauty.jpg";
import image6 from "../Images/Flowers/impression.jpg";
import image7 from "../Images/Flowers/charming-pink-and-white.webp";
import image8 from "../Images/Flowers/divine-story.jpg";
import image9 from "../Images/Flowers/exotic-magic-premium.webp";
import image10 from "../Images/Flowers/love-story.webp";
import image11 from "../Images/Flowers/adoring-darling.jpg";
import image12 from "../Images/Flowers/miss-u-friend.jpg"
import image13 from "../Images/Flowers/Same-Day-11-A_900x.webp";
import image14 from "../Images/Flowers/Love Of My Life.webp";
import image15 from "../Images/Flowers/The Story Of Us.webp";
import image16 from "../Images/Flowers/Secret Scent.webp";
import image17 from "../Images/Flowers/Angel Eyes.webp";
import image18 from "../Images/Flowers/Heartful of love.webp";
import image19 from "../Images/Flowers/The Choice.webp";
import image20 from "../Images/Flowers/You Are My Sunshine.webp";
import image21 from "../Images/Flowers/Beginning Our Forever.webp";
import image22 from "../Images/Flowers/Our Time Together.webp";
import image23 from "../Images/Flowers/Adore You.jpg";
import image24 from "../Images/Flowers/Heartfelt Roses.webp";


let flowers = [
    {
        id: 1,
        img:image1,
        name: "Charming Fantasy - Red Rose Hand Bouquet",
        description : "8 Red Roses Red and Pink Paper Packing Red Ribbon Bow Seasonal Fillers For the birthday and anniversary's we have this bouquet, which offers a charming bouquet of 8 fresh red roses nicely wrapped in a red and pink...",
        price: 449,
    },  
    {
        id: 2,
        img:image2,
        name: "Gorgeous Purple Orchids",
        description : " 6 Stem Purple Orchids Nicely wrapped with premium paper While we always strive to ensure that products are accurately represented in our photographs, from season to season and subject to availability, our florists...",
        price: 699,
    },
    {
        id: 3,
        img: image3,
        name: "Red Carnival",
        description : "24 Red Roses Red Paper Packing Red Ribbon Bow Seasonal Fillers For any occasion like marriage, birthday, anniversary, etc. flowers are the best present to increase the happiness of the occasion manifold, and here we are offering a...",
        price: 999,
    },
    {
        id: 4,
        img:image4,
        name: "Pink Serenity - 12 Pink Roses",
        description : "12 Pink Roses Pink Paper Wrapping Pink Ribbon Bow Seasonal Fillers For a special event that needs your admiration or love, flowers are the best option to express your love as flowers speak louder than words, and for this,...",
        price: 599,
    },
    {
        id: 5,
        img:image5,
        name: "Gorgeous Beauty",
        description : "10 Pink and White Carnation bouquet for your loved ones. Pink and White paper wrapping Pink ribbon bow Seasonal fillers While we always strive to ensure that products are accurately represented in our photographs, from season to...",
        price: 699,
    },
    {
        id: 6,
        img:image6,
        name: "Impression - 100 Red And Pink Roses",
        description : "30 Pink Roses  70 Red Roses White Paper Packing Beautiful Ribbon Bow Seasonal Fillers For beloved ones in your life, who are always there with you in all ups and downs of your life. For them, we have a...",
        price:3599,
    },
    {
        id: 7,
        img:image7,
        name: "Charming Pink And White - Pink And White Rose Bouquet",
        description : "15 Pink and White Roses Pink and White Paper Packing Pink Ribbon Bow Seasonal Fillers  A bouquet which is a duet of pink and white roses are specially designed to fulfil your gifting needs and make your beloved day full...",
        price: 699,
    },
    {
        id: 8,
        img:image8,
        name: "Divine Story",
        description : "5 Red rose  5 Yellow rose 5 Pink Rose 5 White Rose paper wrapping Beautiful ribbon bow Seasonal fillers While we always strive to ensure that products are accurately represented in our photographs, from season to season...",
        price: 849,
    },
    {
        id: 9,
        img:image9,
        name: "Exotic Magic Premium",
        description : "5 Red carnation 5 Pink carnation 5 White carnation White Paper Wrapping Red ribbon bow Seasonal fillers While we always strive to ensure that products are accurately represented in our photographs, from season to season...",
        price: 949,
    },
    {
        id: 10,
        img:image10,
        name: "Love Story",
        description : "20 Red Roses 3 White Oriental Lily Red Paper Packing White Ribbon Bow Seasonal Fillers The first impression is the last impression, and to start a love story, one has to start with a unique gift, something different, unusual...",
        price:1849 ,
    },
    {
        id: 11,
        img:image11,
        name:"Adoring Darling - Mix Roses Bouquet",
        description:"10 red, white and pink roses Red and white paper wrap Green/ Yellow/ White fillers",
        price:549,
    },
    {
        id: 12,
        img: image12,
        name:"Miss U Friend - 10 Yellow Roses",
        description:"10 Yellow Roses  Cellophane Packing Seasonal Fillers Roses are considered as the best flowers when it comes to gifting flowers to your special ones. This bouquet of 10 yellow roses packed with care and love in cellophane packaging...",
        price:549,
    },
    {
        id: 13,
        img: image13,
        name:"A Dream Come True",
        description:"This Special flower bouquet contains : 12 Pink Roses Seasonal fillers (green or white) Nicely wrapped with cellophane While we always strive to ensure that products are accurately represented in our photographs, from season to season and subject to availability,...",
        price:599,
    },
    {
        id: 14,
        img: image14,
        name:"Love Of My Life",
        description:"This Special flower bouquet contains : 30 Pink and White Roses Seasonal fillers (green or white) Nicely wrapped with premium paper While we always strive to ensure that products are accurately represented in our photographs, from season to season and...",
        price:1999,
    },
    {
        id: 15,
        img: image15,
        name:"The Story Of Us",
        description:"This Special flower bouquet contains : 20 Red and Pink Roses Seasonal fillers (green or white) Nicely wrapped with premium paper While we always strive to ensure that products are accurately represented in our photographs, from season to season and...",
        price:849,
    },
    {
        id: 16,
        img: image16,
        name:"Secret Scent",
        description:"This Special flower bouquet contains : 20 Pink Roses Seasonal fillers (green or white) Nicely wrapped with premium paper While we always strive to ensure that products are accurately represented in our photographs, from season to season and subject to...",
        price:849,
    },
    {
        id: 17,
        img: image17,
        name:"Angel Eyes",
        description:"This Special flower bouquet contains : 30 Red Roses Seasonal fillers (green or white) Nicely arranged in a vase While we always strive to ensure that products are accurately represented in our photographs, from season to season and subject to...",
        price:1699,
    },
    {
        id: 18,
        img: image18,
        name:"Heartful Of Love",
        description:"This Special flower bouquet contains : 30 Red Roses Seasonal fillers (green or white) Nicely wrapped with premium paper While we always strive to ensure that products are accurately represented in our photographs, from season to season and subject to...",
        price:1549,
    },
    {
        id: 19,
        img: image19,
        name:"The Choice",
        description:"This Special flower bouquet contains : 10 Red Rose and 10 Pink Roses Seasonal fillers (green or white) Nicely wrapped with premium paper While we always strive to ensure that products are accurately represented in our photographs, from season to...",
        price:1249,
    },
    {
        id: 20,
        img: image20,
        name:"You Are My Sunshine",
        description:"This Special flower bouquet contains : 24 Red, Pink and White Roses Seasonal fillers (green or white) Nicely wrapped with premium paper While we always strive to ensure that products are accurately represented in our photographs, from season to season...",
        price:999,
    },
    {
        id: 21,
        img: image21,
        name:"Beginning Our Forever",
        description:"This Special flower bouquet contains : 25 Red Roses Seasonal fillers (green or white) Nicely arranged in vase While we always strive to ensure that products are accurately represented in our photographs, from season to season and subject to availability,...",
        price:1499,
    },
    {
        id: 22,
        img: image22,
        name:"Our Time Together",
        description:"This Special flower bouquet contains : 40 Red and Pink Roses Seasonal fillers (green or white) Nicely arranged in a vase While we always strive to ensure that products are accurately represented in our photographs, from season to season and...",
        price:2599,
    },
    {
        id: 23,
        img: image23,
        name:"Adore You",
        description:"This Special flower bouquet contains : 143 Red Roses Seasonal fillers (green or white) Nicely arranged in basket While we always strive to ensure that products are accurately represented in our photographs, from season to season and subject to availability,...",
        price:6999,
    },
    {
        id: 24,
        img: image24,
        name:"Heartfelt Roses",
        description:"This Special flower bouquet contains : 20 Red Roses Seasonal fillers (green or white) Nicely wrapped with premium paper While we always strive to ensure that products are accurately represented in our photographs, from season to season and subject to...",
        price:849,
    }
    
]

export default flowers;